import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGroups = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.4286 18V17.0606C21.4286 15.8769 20.4694 14.9177 19.2857 14.9177H18.5991M2.57143 18V17.0606C2.57143 15.8769 3.53057 14.9177 4.71428 14.9177H5.40086M16.5763 18V16.6277C16.5763 14.9709 15.2331 13.6277 13.5763 13.6277H10.4229C8.766 13.6277 7.42285 14.9709 7.42285 16.6277V18M19.5364 9.8773C20.2136 10.5545 20.2136 11.6524 19.5364 12.3295C18.8593 13.0067 17.7614 13.0067 17.0842 12.3295C16.407 11.6524 16.407 10.5545 17.0842 9.8773C17.7614 9.20013 18.8593 9.20013 19.5364 9.8773ZM13.8879 6.78202C14.9306 7.82472 14.9306 9.51527 13.8879 10.558C12.8452 11.6007 11.1547 11.6007 10.112 10.558C9.06929 9.51528 9.06929 7.82473 10.112 6.78202C11.1547 5.73933 12.8452 5.73933 13.8879 6.78202ZM6.91584 9.8773C7.59301 10.5545 7.59301 11.6524 6.91584 12.3295C6.23867 13.0067 5.14076 13.0067 4.4636 12.3295C3.78643 11.6524 3.78643 10.5545 4.4636 9.8773C5.14076 9.20013 6.23867 9.20013 6.91584 9.8773Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgGroups);
export default ForwardRef;
